import { LvisionBetBoosterApiKeys } from '../types';

export const lvisionBetBoosterApiKeys: LvisionBetBoosterApiKeys = {
  prod: 'ad1c1128902a21a3ac15fddf',
  dev: 'y95b6aibi4n3xv5avcdqxlq9'
};
